/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { SetFingerprintRequest } from '../models';
// @ts-ignore
import type { Status } from '../models';
/**
 * IdentityAPIApi - axios parameter creator
 * @export
 */
export const IdentityAPIApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * SetFingerprint stores a unique fingerprint for the authenticated user.
         * @summary Set a unique fingerprint for the authenticated user.
         * @param {SetFingerprintRequest} setFingerprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityAPISetFingerprint: async (setFingerprintRequest: SetFingerprintRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'setFingerprintRequest' is not null or undefined
            assertParamExists('identityAPISetFingerprint', 'setFingerprintRequest', setFingerprintRequest)
            const localVarPath = `/organization-management/v1/users:setFingerprint`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication ApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            // authentication BearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setFingerprintRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IdentityAPIApi - functional programming interface
 * @export
 */
export const IdentityAPIApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IdentityAPIApiAxiosParamCreator(configuration)
    return {
        /**
         * SetFingerprint stores a unique fingerprint for the authenticated user.
         * @summary Set a unique fingerprint for the authenticated user.
         * @param {SetFingerprintRequest} setFingerprintRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async identityAPISetFingerprint(setFingerprintRequest: SetFingerprintRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.identityAPISetFingerprint(setFingerprintRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IdentityAPIApi.identityAPISetFingerprint']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IdentityAPIApi - factory interface
 * @export
 */
export const IdentityAPIApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IdentityAPIApiFp(configuration)
    return {
        /**
         * SetFingerprint stores a unique fingerprint for the authenticated user.
         * @summary Set a unique fingerprint for the authenticated user.
         * @param {IdentityAPIApiIdentityAPISetFingerprintRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        identityAPISetFingerprint(requestParameters: IdentityAPIApiIdentityAPISetFingerprintRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.identityAPISetFingerprint(requestParameters.setFingerprintRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for identityAPISetFingerprint operation in IdentityAPIApi.
 * @export
 * @interface IdentityAPIApiIdentityAPISetFingerprintRequest
 */
export interface IdentityAPIApiIdentityAPISetFingerprintRequest {
    /**
     * 
     * @type {SetFingerprintRequest}
     * @memberof IdentityAPIApiIdentityAPISetFingerprint
     */
    readonly setFingerprintRequest: SetFingerprintRequest
}

/**
 * IdentityAPIApi - object-oriented interface
 * @export
 * @class IdentityAPIApi
 * @extends {BaseAPI}
 */
export class IdentityAPIApi extends BaseAPI {
    /**
     * SetFingerprint stores a unique fingerprint for the authenticated user.
     * @summary Set a unique fingerprint for the authenticated user.
     * @param {IdentityAPIApiIdentityAPISetFingerprintRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IdentityAPIApi
     */
    public identityAPISetFingerprint(requestParameters: IdentityAPIApiIdentityAPISetFingerprintRequest, options?: RawAxiosRequestConfig) {
        return IdentityAPIApiFp(this.configuration).identityAPISetFingerprint(requestParameters.setFingerprintRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

